import { render, staticRenderFns } from "./app-2-project-readme.vue?vue&type=template&id=c2591b10&"
import script from "./app-2-project-readme.vue?vue&type=script&lang=ts&"
export * from "./app-2-project-readme.vue?vue&type=script&lang=ts&"
import style0 from "./app-2-project-readme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VLazy,VProgressCircular})
